(() => {
  if (window.__allbirdsCollectionFiltersBound) return;
  window.__allbirdsCollectionFiltersBound = true;

  const closeFilterPanel = (form) => {
    const button = form?.querySelector('[data-allbirds-filter-toggle]');
    if (!button) return;
    form.classList.remove('is-filter-open');
    button.setAttribute('aria-expanded', 'false');
    button.querySelector('[data-filter-closed-label]')?.classList.remove('hidden');
    button.querySelector('[data-filter-open-label]')?.classList.add('hidden');
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-allbirds-filter-toggle]');
    if (button) {
      const form = button.closest('.facets__form');
      const isOpen = form.classList.toggle('is-filter-open');
      button.setAttribute('aria-expanded', String(isOpen));
      button.querySelector('[data-filter-closed-label]')?.classList.toggle('hidden', isOpen);
      button.querySelector('[data-filter-open-label]')?.classList.toggle('hidden', !isOpen);
      return;
    }

    document.querySelectorAll('.facets__form.is-filter-open').forEach((form) => {
      if (!form.contains(event.target)) closeFilterPanel(form);
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.facets__form.is-filter-open').forEach(closeFilterPanel);
  });
})();
